import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  Typography,
  TextField,
} from '@material-ui/core';

import {
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';

import ImageUploader from "../../components/ImageUploader";
import { SettingAction } from 'src/actions/setting.action';

const Settings = (props) => {
    const maximumBanner = 12;
    const maximumBankAccount = 4;
    const dispatch = useDispatch();
    const [images, setImages] = useState({});
    const [links, setLinks] = useState({});
    const [bankAccounts, setBankAccounts] = useState({});
    const [copyright, setCopyright] = useState("");
    const [address, setAddress] = useState("");
    const [hotline, setHotline] = useState("");
    const [facebook, setFacebook] = useState("");
    const [zalo, setZalo] = useState("");

    useEffect(() => {
        async function fetchData() {
            const homepageSettings = await dispatch(SettingAction.getHomepageKeys([
                {
                    "key": "banner",
                },
                {
                    "key": "copyright",
                },
                {
                    "key": "address",
                },
                {
                    "key": "hotline",
                },
                {
                    "key": "facebook",
                },
                {
                    "key": "zalo",
                },
                {
                    "key": "bank_account",
                },
            ]))
          
            if (homepageSettings) {
                try {
                    let banner = JSON.parse(homepageSettings.data.banner);
                    console.log(banner);

                    if (banner) {
                        let tmpImages = {};
                        let tmpLinks = {};

                        if (Object.entries(banner).length > 0) {
                            Object.entries(banner).forEach(([key, value]) => {
                                tmpImages[key] = value.banner_url;
                                tmpLinks[key] = value.banner_link;
                            });

                            setImages(tmpImages);
                            setLinks(tmpLinks);
                        }
                    }
                } catch (error) {
                    console.error(error);
                }

                //==========

                try {
                    let bank_account = JSON.parse(homepageSettings.data.bank_account);
                    console.log(bank_account);

                    if (bank_account) {
                        setBankAccounts(bank_account);
                    }
                } catch (error) {
                    console.error(error);
                }

                //==========

                try {
                    let _copyright = homepageSettings.data.copyright;
                    setCopyright(_copyright);
                } catch (error) {
                    console.error(error);
                }

                //==========

                try {
                    let _address = homepageSettings.data.address;
                    setAddress(_address);
                } catch (error) {
                    console.error(error);
                }

                //==========

                try {
                    let _hotline = homepageSettings.data.hotline;
                    setHotline(_hotline);
                } catch (error) {
                    console.error(error);
                }

                //==========

                try {
                    let _zalo = homepageSettings.data.zalo;
                    setZalo(_zalo);
                } catch (error) {
                    console.error(error);
                }

                //==========

                try {
                    let _facebook = homepageSettings.data.facebook;
                    setFacebook(_facebook);
                } catch (error) {
                    console.error(error);
                }
            }
        }
        fetchData();
    }, [])

    const handleImageUpload = (imageUrl, index = 0) => {
        setImages({
            ...images,
            [index]: imageUrl,
        });
    };

    const handleLink = (value, index = 0) => {
        setLinks({
            ...links,
            [index]: value,
        });
    };

    const handleBankAccount = (value, index = 0, key) => {
        setBankAccounts({
            ...bankAccounts,
            [index]: {
                ...bankAccounts[index],
                [key]: value,
            }
        });

        console.log(bankAccounts)
    };

    const deleteBannerIndex = (index = 0) => {
        const newImages = { ...images };
        const newLinks = { ...links };

        delete newImages[index];
        delete newLinks[index];

        setImages(newImages);
        setLinks(newLinks);
    };

    const deleteBankAccountIndex = (index = 0) => {
        const newBankAccounts = { ...bankAccounts };

        delete newBankAccounts[index];

        setBankAccounts(newBankAccounts);
    };

    const updateBanners = async () => {        
        try {
            let saveBanner = {}

            if (Object.entries(images).length > 0) {
                Object.entries(images).forEach(([key, imageUrl]) => {
                    if (links.hasOwnProperty(key)) {
                        const linkValue = links[key];

                        saveBanner[key] = {
                            "banner_url": imageUrl,
                            "banner_link": linkValue,
                        }
                    } else {
                        //
                    }
                });
            }

            console.log(saveBanner);

            if (saveBanner) {
                saveBanner = JSON.stringify(saveBanner);
            }

            let response = await dispatch(SettingAction.update("banner", { value: saveBanner }));
            console.log(response)
            if (typeof response.status !== 'undefined' && response.status == 'success') alert("Cập nhật cài đặt thành công");
            else if (typeof response.code !== 'undefined' && typeof response.msg !== 'undefined') alert("[Lỗi]\n"+response.msg)
        } catch (error) {
            if (typeof error.code !== 'undefined' && typeof error.msg !== 'undefined') alert("[Lỗi]\n"+error.msg)
        }
    }

    const updateBankAccounts = async () => {        
        try {
            let saveBankAccount = JSON.stringify(bankAccounts);

            let response = await dispatch(SettingAction.update("bank_account", { value: saveBankAccount }));
            console.log(response)
            if (typeof response.status !== 'undefined' && response.status == 'success') alert("Cập nhật cài đặt thành công");
            else if (typeof response.code !== 'undefined' && typeof response.msg !== 'undefined') alert("[Lỗi]\n"+response.msg)
        } catch (error) {
            if (typeof error.code !== 'undefined' && typeof error.msg !== 'undefined') alert("[Lỗi]\n"+error.msg)
        }
    }

    const updateThongTinKhac = async () => {        
        try {
            let response = await dispatch(SettingAction.update("copyright", { value: copyright }));
            response = await dispatch(SettingAction.update("address", { value: address }));
            response = await dispatch(SettingAction.update("hotline", { value: hotline }));
            response = await dispatch(SettingAction.update("zalo", { value: zalo }));
            response = await dispatch(SettingAction.update("facebook", { value: facebook }));
            console.log(response)
            if (typeof response.status !== 'undefined' && response.status == 'success') alert("Cập nhật cài đặt thành công");
            else if (typeof response.code !== 'undefined' && typeof response.msg !== 'undefined') alert("[Lỗi]\n"+response.msg)
        } catch (error) {
            if (typeof error.code !== 'undefined' && typeof error.msg !== 'undefined') alert("[Lỗi]\n"+error.msg)
        }
    }

    return (
        <form {...props}>
            <Card style={{marginBottom: 15}}>
                <CardHeader subheader={`Tối đa ${maximumBanner} ảnh. Kích thước: 1000x220`} title="Banner chính" />
                <Divider />
                <CardContent>
                    <Grid container spacing={6} wrap="wrap">
                        {Array.from({ length: maximumBanner }).map((_, index) => (
                            <Grid item md={3} xs={6} key={index}>
                                <Typography className='checkbox-container' variant="body1">
                                    Banner {index + 1}
                                    {images[index] && <Button style={{width: 20, minWidth: 20, height: 20, padding: 0, margin: "0 0 5px 5px"}} color="error" variant="contained" onClick={() => {deleteBannerIndex(index)}}>
                                        X
                                    </Button>}
                                </Typography>
                                <div style={{ width: "100%" }}>
                                    <ImageUploader
                                        onUploadSuccess={(imageUrl, uploaderIndex) => handleImageUpload(imageUrl, uploaderIndex)}
                                        initialImage={images[index] ? images[index] : ""}
                                        uploaderIndex={index}
                                    />
                                </div>
                                <TextField
                                    fullWidth
                                    label={"Link " + (index + 1)}
                                    margin="normal"
                                    onChange={(e) => handleLink(e.target.value, index)}
                                    type="text"
                                    value={links[index] ? links[index] : ""}
                                    variant="outlined"
                                />
                            </Grid>
                        ))}
                    </Grid>
                </CardContent>
                <Divider />
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        p: 2,
                    }}
                >
                    <Button className="setting-update-btn" color="primary" variant="contained" onClick={updateBanners}>
                        Cập nhật
                    </Button>
                </Box>
            </Card>
            <Card style={{marginBottom: 15}}>
                <CardHeader subheader={`Tối đa ${maximumBankAccount} tài khoản`} title="Tài khoản ngân hàng" />
                <Divider />
                <CardContent>
                    <Grid container spacing={6} wrap="wrap">
                        {Array.from({ length: maximumBankAccount }).map((_, index) => (
                            <Grid item md={3} xs={6} key={index}>
                                <Typography className='checkbox-container' variant="body1">
                                    Tài khoản ngân hàng {index + 1}
                                    {bankAccounts[index] && <Button style={{width: 20, minWidth: 20, height: 20, padding: 0, margin: "0 0 5px 5px"}} color="error" variant="contained" onClick={() => {deleteBankAccountIndex(index)}}>
                                        X
                                    </Button>}
                                </Typography>
                                <TextField
                                    fullWidth
                                    label={"Tên ngân hàng "}
                                    margin="normal"
                                    onChange={(e) => handleBankAccount(e.target.value, index, 'bankName')}
                                    type="text"
                                    value={bankAccounts[index] && bankAccounts[index]['bankName'] ? bankAccounts[index]['bankName'] : ""}
                                    variant="outlined"
                                />
                                <TextField
                                    fullWidth
                                    label={"Số tài khoản "}
                                    margin="normal"
                                    onChange={(e) => handleBankAccount(e.target.value, index, 'bankAccountNumber')}
                                    type="text"
                                    value={bankAccounts[index] && bankAccounts[index]['bankAccountNumber'] ? bankAccounts[index]['bankAccountNumber'] : ""}
                                    variant="outlined"
                                />
                                <TextField
                                    fullWidth
                                    label={"Chủ tài khoản "}
                                    margin="normal"
                                    onChange={(e) => handleBankAccount(e.target.value, index, 'bankAccountOwner')}
                                    type="text"
                                    value={bankAccounts[index] && bankAccounts[index]['bankAccountOwner'] ? bankAccounts[index]['bankAccountOwner'] : ""}
                                    variant="outlined"
                                />
                            </Grid>
                        ))}
                    </Grid>
                </CardContent>
                <Divider />
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        p: 2,
                    }}
                >
                    <Button className="setting-update-btn" color="primary" variant="contained" onClick={updateBankAccounts}>
                        Cập nhật
                    </Button>
                </Box>
            </Card>
            <Card style={{marginBottom: 15}}>
                <CardHeader subheader={``} title="Thông tin khác" />
                <Divider />
                <CardContent>
                    <Grid container spacing={3} wrap="wrap">
                            <Grid item md={3} xs={6}>
                                <TextField
                                    fullWidth
                                    label="Copyright"
                                    margin="normal"
                                    onChange={(e) => setCopyright(e.target.value)}
                                    type="text"
                                    value={copyright ? copyright : ""}
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid item md={3} xs={6}>
                                <TextField
                                    fullWidth
                                    label="Địa chỉ"
                                    margin="normal"
                                    onChange={(e) => setAddress(e.target.value)}
                                    type="text"
                                    value={address ? address : ""}
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid item md={3} xs={6}>
                                <TextField
                                    fullWidth
                                    label="Hotline"
                                    margin="normal"
                                    onChange={(e) => setHotline(e.target.value)}
                                    type="text"
                                    value={hotline ? hotline : ""}
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid item md={3} xs={6}>
                                <TextField
                                    fullWidth
                                    label="Zalo"
                                    margin="normal"
                                    onChange={(e) => setZalo(e.target.value)}
                                    type="text"
                                    value={zalo ? zalo : ""}
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid item md={3} xs={6}>
                                <TextField
                                    fullWidth
                                    label="Facebook"
                                    margin="normal"
                                    onChange={(e) => setFacebook(e.target.value)}
                                    type="text"
                                    value={facebook ? facebook : ""}
                                    variant="outlined"
                                />
                            </Grid>
                    </Grid>
                </CardContent>
                <Divider />
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        p: 2,
                    }}
                >
                    <Button className="setting-update-btn" color="primary" variant="contained" onClick={updateThongTinKhac}>
                        Cập nhật
                    </Button>
                </Box>
            </Card>
        </form>
    );
}

export default Settings;
